<section>
  <app-style-guide-nav></app-style-guide-nav>

  <!-- https://fonts.google.com/icons?selected=Material+Icons -->

  <h3>Icons</h3>

  <div *ngFor="let icon of iconList">
    <mat-icon>{{ icon }}</mat-icon>
    <mat-icon color="primary">{{ icon }}</mat-icon>
    <mat-icon color="accent">{{ icon }}</mat-icon>
    <mat-icon color="warn">{{ icon }}</mat-icon>
  </div>

  <h3>Icon buttons</h3>

  <div *ngFor="let icon of iconList">
    <button mat-icon-button>
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-icon-button
      color="primary">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-icon-button
      color="accent">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-icon-button
      color="warn">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-icon-button
      disabled>
      <mat-icon>{{ icon }}</mat-icon>
    </button>
  </div>

  <h3>Fab icon buttons</h3>

  <div *ngFor="let icon of iconList">
    <button mat-fab>
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-fab
      color="primary">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-fab
      color="accent">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-fab
      color="warn">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-fab
      disabled>
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <a
      mat-fab
      routerLink="."
      >Link</a
    >
  </div>

  <h3>Fab icon buttons</h3>

  <div *ngFor="let icon of iconList">
    <button mat-mini-fab>
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-mini-fab
      color="primary">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-mini-fab
      color="accent">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-mini-fab
      color="warn">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      mat-mini-fab
      disabled>
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <a
      mat-mini-fab
      routerLink="."
      >Link</a
    >
  </div>
</section>
